import { useTranslation } from "react-i18next"

import type { UsageKPI } from "../../types"

import {
  Download,
  Layers,
  type LucideIcon,
  PlayCircle,
  Presentation,
  Users,
} from "@/components/icons"
import { Card, CardContent } from "@/components/ui/card"

export function SlideUsageKPIs({ kpi }: { kpi: UsageKPI }) {
  const { t } = useTranslation()
  return (
    <div className="mb-6 grid grid-cols-2 gap-4 md:grid-cols-5">
      <KpiCard
        icon={Users}
        label={t("slideSense.usage.kpi.activeUsers")}
        testId="kpi-active-users"
        value={kpi.active_users}
      />
      <KpiCard
        icon={Download}
        label={t("slideSense.usage.kpi.totalExports")}
        testId="kpi-total-exports"
        value={kpi.total_exports}
      />
      <KpiCard
        icon={Presentation}
        label={t("slideSense.usage.kpi.totalPresentations")}
        testId="kpi-total-presentations"
        value={kpi.total_presentations}
      />
      <KpiCard
        icon={PlayCircle}
        label={t("slideSense.usage.kpi.presentationSessions")}
        testId="kpi-presentation-sessions"
        value={kpi.presentation_sessions}
      />
      <KpiCard
        icon={Layers}
        label={t("slideSense.usage.kpi.distinctSlidesUsed")}
        testId="kpi-distinct-slides-used"
        value={kpi.distinct_slides_used}
      />
    </div>
  )
}

function KpiCard({
  label,
  value,
  testId,
  icon: Icon,
}: {
  label: string
  value: number
  testId: string
  icon: LucideIcon
}) {
  const { i18n } = useTranslation()
  return (
    <Card className="card-interactive rounded-lg shadow-sm" data-testid={testId}>
      <CardContent
        aria-label={`${label}: ${value}`}
        className="flex items-center gap-4 p-5"
        role="status"
      >
        <div className="bg-muted rounded-xl p-3">
          <Icon aria-hidden className="size-6" />
        </div>
        <div className="flex-1">
          <div className="text-2xl leading-tight font-semibold tabular-nums">
            {value.toLocaleString(i18n.language)}
          </div>
          <div className="text-muted-foreground text-sm">{label}</div>
        </div>
      </CardContent>
    </Card>
  )
}
